import { useEffect, useState } from 'react';
import { createMVCommentAttachmentsUppy } from '@services/MVCommentAttachmentsUppy';

function createUppy(assetId: string) {
  return createMVCommentAttachmentsUppy(assetId);
}

export function useMVCommentAttachUppy(assetId: string) {
  const [ctx, setCtx] = useState(() => createUppy(assetId));

  useEffect(() => {
    return () => {
      setCtx((prev) => {
        prev.uppy.destroy();
        return createUppy(assetId);
      });
    };
  }, [assetId]);

  return ctx.uppy;
}
